import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { UserService } from '@shared/services';
import { Observable } from 'rxjs';
import { debounceTime, filter, map, switchMap } from 'rxjs/operators';

@Component({
  selector: 'mojo-candidate-input',
  templateUrl: './candidate-input.component.html',
  styleUrls: ['./candidate-input.component.scss'],
})
export class CandidateInputComponent implements OnInit {
  @Input() label: string;
  @Input() form: UntypedFormGroup;
  @Input() controlName: string;
  @Input() width;
  @Output() selectOption = new EventEmitter<void>();

  users$: Observable<any>;

  constructor(private userService: UserService) {}

  ngOnInit(): void {
    this.users$ = this.form.get(this.controlName).valueChanges.pipe(
      filter((name) => typeof name === 'string'),
      map((name: string) => name.split(',')[0]),
      debounceTime(250),
      switchMap((name: string) =>
        this.userService.get({ params: { search: encodeURIComponent(name), onlyActive: true } }),
      ),
    );
  }

  getName() {
    if (this.form?.get(this.controlName)?.value?.name) {
      return this.form.get(this.controlName)?.value.name;
    }
  }

  getUsers(users) {
    return users?.filter((res) => res?.role?.id !== 35);
  }

  onSelectOption() {
    setTimeout(() => this.selectOption.emit(), 0);
  }
}
